import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './Instructions.module.scss';

export const Instructions = () => {
    return (
        <div className={styles['instructions-container']}>
            <FormattedMessage
                id="pixel.tester.website.instructions.title"
                defaultMessage="How it works"
                className={styles['title-text']}
            />
            <ol className={styles['instructions-list']}>
                <li className={styles['instructions-list-item']}>
                    <FormattedMessage
                        id="pixel.tester.website.instructions.item1"
                        defaultMessage="<strong>Enter the URL:</strong> Input the web address where your events are embedded."
                    />
                </li>
                <li className={styles['instructions-list-item']}>
                    <FormattedMessage
                        id="pixel.tester.website.instructions.item2"
                        defaultMessage="<strong>Scan the QR Code:</strong> Use your mobile device to scan the QR code. This allows you to interact with your website and trigger the embedded events."
                    />
                </li>
                <li className={styles['instructions-list-item']}>
                    <FormattedMessage
                        id="pixel.tester.website.instructions.item3"
                        defaultMessage="<strong>View the Events:</strong> Once the events are successfully received, they will appear in the panel."
                    />
                </li>
            </ol>
        </div>
    );
};
